<template>
  <b-form-group id="favorit-label" label-for="periode" class="p-1">
    <template #label>
      <div class="d-flex justify-content-between align-items-center">
        <label>{{ $t('report.object.reportPeriod') }}</label>
        <span v-b-tooltip.topleft :title="periodeTitle">
          <i class="icon-outline_info"></i>
        </span>
      </div>
    </template>
    <mc-date-picker
      v-if="
        checkReportKey('detail-history-vehicle') ||
        checkReportKey('fuel') ||
        checkReportKey('temperature') ||
        checkReportKey('alert')
      "
      ref="periodePicker"
      v-model="periode"
      type="datetime"
      format="DD MMM YYYY HH:mm:ss"
      :shortcuts="makeShortcuts"
      range-separator=" - "
      range
      :draft="true"
      value-type="YYYY-MM-DD HH:mm:ss"
      :default-value="datetimeDefaultValue"
      :normalize-range-end="normalizeDateTimeRangeEnd"
      :placeholder="$t('report.object.reportPeriod')"
      :disabled-date="disabledRange"
      :confirm="true"
      :confirm-text="$t('global.action.apply')"
      :editable="false"
      :lang="datePickerLang"
      @calendar-change="handleMaxDate"
      @pick="pickDate"
      @close="closePicker"
    >
      <template #footer>
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
          {{ $t('global.action.cancel') }}
        </b-button>
      </template>
    </mc-date-picker>
    <date-picker
      v-else-if="
        checkReportKey('summary-engine-pto') ||
        checkReportKey('driver-score') ||
        checkReportKey('driver-score-v2') ||
        checkReportKey('summary-alert') ||
        (checkReportKey('fuel-recapitulation') && reportType == monthlyReportType)
      "
      ref="periodePicker"
      v-model="periodeMonth"
      type="month"
      format="MMM YYYY"
      value-type="YYYY-MM-DD"
      :placeholder="$t('report.object.reportPeriod')"
      :confirm="true"
      :confirm-text="$t('global.action.apply')"
      :disabled-date="disabledRange"
      :editable="false"
      :lang="datePickerLang"
      @calendar-change="handleMaxDate"
      @pick="pickDate"
      @close="closePicker"
    >
      <template #footer>
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
          {{ $t('global.action.cancel') }}
        </b-button>
      </template>
    </date-picker>
    <mc-date-picker
      v-else-if="checkReportKey('fuel-recapitulation') && reportType == weeklyReportType"
      :key="weeklyPeriodKey"
      ref="periodePicker"
      v-model="periode"
      range-separator=" - "
      range
      :draft="true"
      type="week"
      format="DD MMM YYYY"
      value-type="YYYY-MM-DD"
      :placeholder="$t('report.object.reportPeriod')"
      :confirm="true"
      :confirm-text="$t('global.action.apply')"
      :disabled-date="disabledRange"
      :editable="false"
      :lang="datePickerLang"
      @calendar-change="handleMaxDate"
      @pick="pickDate"
      @close="closePicker"
    >
      <template #footer>
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
          {{ $t('global.action.cancel') }}
        </b-button>
      </template>
    </mc-date-picker>
    <mc-date-picker
      v-else
      ref="periodePicker"
      v-model="periode"
      type="date"
      format="DD MMM YYYY"
      :shortcuts="makeShortcuts"
      range-separator=" - "
      range
      :draft="true"
      value-type="YYYY-MM-DD"
      :placeholder="$t('report.object.reportPeriod')"
      :disabled-date="disabledRange"
      :confirm="true"
      :confirm-text="$t('global.action.apply')"
      :disabled="checkReportKey('offline-vehicle')"
      :editable="false"
      :lang="datePickerLang"
      @calendar-change="handleMaxDate"
      @pick="pickDate"
      @close="closePicker"
    >
      <template #footer>
        <b-button class="mx-2" variant="outline-primary" @click="closeCalendar()">
          {{ $t('global.action.cancel') }}
        </b-button>
      </template>
    </mc-date-picker>
  </b-form-group>
</template>
<script>
import { mapCsv, mapPeriode31DaysLeft } from '../../../../lib/reportKeyLists.js'
import datePickerLang from '@/helpers/date-picker-lang'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import McDatePicker from '@/components/McDatePicker'
export default {
  components: { McDatePicker },
  mixins: [Helper],
  props: {
    report: {
      type: Object,
      required: true,
    },
  },
  emits: ['update'],
  data() {
    return {
      periode: [],
      periodeMonth: null,
      pastDate: moment().subtract(6, 'months'),
      futureEnd: moment().add(6, 'months'),
      currentPastDate: moment().subtract(6, 'months'),
      currentFutureEnd: moment().add(6, 'months'),
      dateType: null,
      threeMonths: 3,
      sixMonths: 6,
      oneYear: 12,
      monthlyReportType: 'monthly',
      weeklyReportType: 'weekly',
      reportType: 'weekly',
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      getFeatureFlagData: 'identity/getFeatureFlagData',
    }),
    datetimeDefaultValue() {
      return [moment().startOf('day').toDate(), moment().endOf('day').toDate()]
    },
    hasCsvScope() {
      return (
        this.report.downloadOptions?.includes('csv') &&
        (this.hasAccess(['csv_report:read']) ||
          (this.hasAccess(['csv_report_plus:read']) && this.checkReportKey('summary-stopped')))
      )
    },

    shortcutsToday() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, dateEnd]
    },

    shortcutsYesterday() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    },

    shortcuts3DaysLeft() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 2)
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, dateEnd]
    },

    shortcuts7DaysLeft() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 6)
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, dateEnd]
    },
    shortcuts31DaysLeft() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24 * 30)
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, dateEnd]
    },

    makeShortcuts() {
      if (this.checkReportKey('cost-analysis')) {
        return [
          { text: this.$t('global.time.today'), onClick: () => [...this.shortcutsToday] },
          { text: this.$t('global.time.yesterday'), onClick: () => [...this.shortcutsYesterday] },
          { text: this.$t('global.time.last3Days'), onClick: () => [...this.shortcuts3DaysLeft] },
          { text: this.$t('global.time.last7Days'), onClick: () => [...this.shortcuts7DaysLeft] },
          { text: this.$t('global.time.last31Days'), onClick: () => [...this.shortcuts31DaysLeft] },
        ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
      }

      if (mapCsv.includes(this.report.key) || mapCsv.includes(this.report.reportKey)) {
        const shortCuts = [
          {
            text: this.$t('global.time.today'),
            onClick: () => this.setShortcuts('today'),
            value: () => this.shortcutsToday,
          },
          {
            text: this.$t('global.time.yesterday'),
            onClick: () => this.setShortcuts('yesterday'),
            value: () => this.shortcutsYesterday,
          },
          {
            text: this.$t('global.time.last3Days'),
            onClick: () => this.setShortcuts('last3days'),
            value: () => this.shortcuts3DaysLeft,
          },
          {
            text: this.$t('global.time.last7Days'),
            onClick: () => this.setShortcuts('last7days'),
            value: () => this.shortcuts7DaysLeft,
          },
        ]
        if (this.hasCsvScope) {
          shortCuts.push({
            text: this.$t('global.time.last31Days'),
            onClick: () => this.setShortcuts('last31days'),
            value: () => this.shortcuts31DaysLeft,
          })
        }
        return shortCuts
      }

      if (
        mapPeriode31DaysLeft.includes(this.report.key) ||
        mapPeriode31DaysLeft.includes(this.report.reportKey)
      ) {
        return [
          {
            text: this.$t('global.time.today'),
            onClick: () => this.setShortcuts('today'),
            value: () => this.shortcutsToday,
          },
          {
            text: this.$t('global.time.yesterday'),
            onClick: () => this.setShortcuts('yesterday'),
            value: () => this.shortcutsYesterday,
          },
          {
            text: this.$t('global.time.last7Days'),
            onClick: () => this.setShortcuts('last7days'),
            value: () => this.shortcuts7DaysLeft,
          },
          {
            text: this.$t('global.time.last31Days'),
            onClick: () => this.setShortcuts('last31days'),
            value: () => this.shortcuts31DaysLeft,
          },
        ]
      }

      return [
        {
          text: this.$t('global.time.today'),
          onClick: () => this.setShortcuts('today'),
          value: () => this.shortcutsToday,
        },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => this.setShortcuts('yesterday'),
          value: () => this.shortcutsYesterday,
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => this.setShortcuts('last7days'),
          value: () => this.shortcuts7DaysLeft,
        },
      ]
    },

    datePickerLang() {
      return datePickerLang()
    },

    periodeTitle() {
      if (
        this.checkReportKey('temperature') ||
        this.checkReportKey('fuel') ||
        this.checkReportKey('detail-history-vehicle') ||
        this.checkReportKey('alert')
      )
        return this.$t('report.text.reportPeriodMaximum3Months')
      else if (this.checkReportKey('expenses')) return this.$t('global.validation.reportPeriod')
      else return this.$t('report.text.reportPeriodMaximum')
    },
  },
  mounted() {
    if (
      this.checkReportKey('temperature') ||
      this.checkReportKey('fuel') ||
      this.checkReportKey('detail-history-vehicle') ||
      this.checkReportKey('alert')
    ) {
      this.pastDate = moment().subtract(this.threeMonths, 'months')
      this.futureEnd = moment().add(this.threeMonths, 'months')
      this.currentPastDate = moment().subtract(this.threeMonths, 'months')
      this.currentFutureEnd = moment().add(this.threeMonths, 'months')
    } else {
      this.pastDate = moment().subtract(this.sixMonths, 'months')
      this.futureEnd = moment().add(this.sixMonths, 'months')
      this.currentPastDate = moment().subtract(this.sixMonths, 'months')
      this.currentFutureEnd = moment().add(this.sixMonths, 'months')
    }
    if (this.getIsBypass()) {
      this.pastDate = moment().subtract(this.oneYear, 'months')
      this.futureEnd = moment().add(this.oneYear, 'months')
      this.currentPastDate = moment().subtract(this.oneYear, 'months')
      this.currentFutureEnd = moment().add(this.oneYear, 'months')
    }
  },
  methods: {
    normalizeDateTimeRangeEnd(date) {
      const periodEnd = moment(date)

      if (!periodEnd.isSame(periodEnd.clone().startOf('day'))) return periodEnd.toDate()

      return (periodEnd.isSame(moment(), 'day') ? moment() : periodEnd.endOf('day')).toDate()
    },
    checkReportKey(key) {
      return this.report.key === key || this.report.reportKey === key
    },
    UpdateReportType(value, oldValue) {
      if (value != oldValue && this.checkReportKey('fuel-recapitulation')) {
        this.periode = []
        this.periodeMonth = null
        this.reportType = value
      }
    },
    SetPeriod(value) {
      this.periode = value.periode
      this.periodeMonth = value.periodeMonth
      this.dateType = value.dateType
    },
    transformDate(date) {
      const formatDate =
        this.checkReportKey('detail-history-vehicle') ||
        this.checkReportKey('fuel') ||
        this.checkReportKey('temperature') ||
        this.checkReportKey('alert')
          ? 'YYYY-MM-DD HH:mm:ss'
          : 'YYYY-MM-DD'
      return moment(new Date(date)).format(formatDate)
    },
    setShortcuts(type) {
      this.dateType = type
      switch (type) {
        case 'today':
          return this.shortcutsToday
        case 'yesterday':
          return this.shortcutsYesterday
        case 'last3days':
          return this.shortcuts3DaysLeft
        case 'last7days':
          return this.shortcuts7DaysLeft
        case 'last31days':
          return this.shortcuts31DaysLeft
      }
    },
    closeCalendar() {
      this.closePicker()
      this.$refs.periodePicker.cancel()
    },
    closePicker() {
      if (
        this.checkReportKey('temperature') ||
        this.checkReportKey('fuel') ||
        this.checkReportKey('detail-history-vehicle') ||
        this.checkReportKey('alert')
      ) {
        this.currentPastDate = moment().subtract(this.threeMonths, 'months')
        this.currentFutureEnd = moment().add(this.threeMonths, 'months')
      } else {
        this.currentPastDate = moment().subtract(this.sixMonths, 'months')
        this.currentFutureEnd = moment().add(this.sixMonths, 'months')
      }
      if (this.getIsBypass()) {
        this.currentPastDate = moment().subtract(this.oneYear, 'months')
        this.currentFutureEnd = moment().add(this.oneYear, 'months')
      }
      if (this.checkReportKey('fuel-recapitulation') && this.reportType == this.weeklyReportType) {
        const startDateWeekNumber = this.getWeek(new Date(this.periode[0])) - 1
        const endDateWeekNumber = this.getWeek(new Date(this.periode[1])) - 1
        this.periode = [
          this.transformDate(
            this.getStartEndOfWeek(startDateWeekNumber, new Date(this.periode[0]))[0]
          ),
          this.transformDate(
            this.getStartEndOfWeek(endDateWeekNumber, new Date(this.periode[1]))[1]
          ),
        ]
      }
      if (
        this.periode?.length > 1 &&
        (this.checkReportKey('detail-history-vehicle') ||
          this.checkReportKey('fuel') ||
          this.checkReportKey('temperature') ||
          this.checkReportKey('alert'))
      ) {
        const normalizedPeriodEnd = moment(this.normalizeDateTimeRangeEnd(this.periode[1]))
        this.$set(this.periode, 1, normalizedPeriodEnd.format('YYYY-MM-DD HH:mm:ss'))
      }
      this.$emit('update', {
        periode: this.periode,
        periodeMonth: this.periodeMonth,
        dateType: this.dateType,
      })
    },
    pickDate(date) {
      this.dateType = null
      let maxDate = 7

      if (
        mapPeriode31DaysLeft.includes(this.report.key) ||
        mapPeriode31DaysLeft.includes(this.report.reportKey) ||
        ((mapCsv.includes(this.report.key) || mapCsv.includes(this.report.reportKey)) &&
          this.hasCsvScope) ||
        this.checkReportKey('cost-analysis')
      ) {
        maxDate = 31
      }

      if (this.checkReportKey('fuel-recapitulation') && this.reportType == this.weeklyReportType) {
        const weekNumber = this.getWeek(new Date(date))
        const prevWeekNumber = weekNumber - 4
        const nextWeekNumber = weekNumber + 2

        const pastDate = new Date(this.getStartEndOfWeek(prevWeekNumber, new Date(date))[0])
        pastDate.setDate(pastDate.getDate() - 1)

        const futureDate = new Date(this.getStartEndOfWeek(nextWeekNumber, new Date(date))[1])
        futureDate.setDate(futureDate.getDate() + 1)

        this.currentPastDate = moment(this.transformDate(pastDate))
        this.currentFutureEnd = moment(this.transformDate(futureDate))
        return
      }

      if (
        this.checkReportKey('summary-engine-pto') ||
        this.checkReportKey('driver-score') ||
        this.checkReportKey('driver-score-v2') ||
        this.checkReportKey('summary-alert') ||
        (this.checkReportKey('fuel-recapitulation') && this.reportType == this.monthlyReportType)
      ) {
        this.periode = this.momentFirstAndEnd(date)
        return
      }

      this.currentPastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)
      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000).toString() == new Date().toString()) {
        this.currentFutureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.currentFutureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
      this.$emit('update', {
        periode: this.periode,
        periodeMonth: this.periodeMonth,
        dateType: this.dateType,
      })
    },

    handleMaxDate(date) {
      const reportConfig = {
        'service-schedules': { monthAdjust: 3, param: 3 },
        'detail-history-vehicle': { param: 3 },
        fuel: { param: 3 },
        temperature: { param: 3 },
        alert: { param: 3 },
        'driver-score-v2': { param: 6 },
        'fuel-recapitulation': { monthAdjust: -1, param: 12 },
      }

      let limit = new Date()
      let param = 6 // Default param

      const reportKey = Object.keys(reportConfig).find((key) => this.checkReportKey(key))

      if (reportKey) {
        const config = reportConfig[reportKey]

        if (config.monthAdjust) {
          limit.setMonth(limit.getMonth() + config.monthAdjust)
          limit = new Date(limit)
        }

        if (reportKey === 'driver-score-v2') {
          const dateParam = JSON.parse(this.getFeatureFlagData('vsms2_driverscore').value)
          this.currentPastDate = new Date(dateParam.active_date)
        }

        param = config.param
      }

      if (this.getIsBypass()) {
        param = this.oneYear
      }

      const isInvalidDate =
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit

      if (isInvalidDate) {
        this.$mcToast.error(
          `${this.$t('global.field.maximum')} ${param} ${this.$t('report.text.monthAgo')}`
        )
      }
    },
    disabledRange: function (date) {
      let limit = new Date()
      if (this.checkReportKey('service-schedules')) {
        limit.setMonth(limit.getMonth() + 3)
        limit = new Date(limit)
      }
      if (this.checkReportKey('driver-score-v2')) {
        const dateParam = JSON.parse(this.getFeatureFlagData('vsms2_driverscore').value)
        this.currentPastDate = new Date(dateParam.active_date)
      }
      if (this.checkReportKey('fuel-recapitulation') && this.reportType == this.monthlyReportType) {
        limit.setMonth(limit.getMonth() - 1)
      }
      return (
        date <= this.pastDate ||
        date >= this.futureEnd ||
        date <= this.currentPastDate ||
        date >= this.currentFutureEnd ||
        date > limit
      )
    },
  },
}
</script>
